import React from 'react';
import { Label } from '@patternfly/react-core';
import { gpuServerStatusLabel } from './gpuServerStatus';

/** A GPU server's customer-facing status (§ "Statuses"); an unknown status renders as-is, in grey. */
const GpuServerStatusLabel: React.FunctionComponent<{ status: string; isCompact?: boolean }> = ({
  status,
  isCompact = false,
}) => {
  const { label, color } = gpuServerStatusLabel(status);
  return (
    <Label color={color} isCompact={isCompact}>
      {label}
    </Label>
  );
};

export default GpuServerStatusLabel;
